export default "__VITE_ASSET__DBzNq5bp__"